import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../api/main/appStore";
import { useEffect } from "react";
import UnconfirmedTransferTable from "../tables/UnconfirmedTransferTable";

export default observer(function UnconfirmedTransfer() {
  const { commonStore, manualTransferStore } = useStore();

  useEffect(() => {
    (async () => {
      try {
        commonStore.setLoading(true);

        await manualTransferStore.getManualTransfers({
          isConfirmed: false,
          pageNumber: 1,
          pageSize: 100,
        });
      } catch (error) {
        commonStore.handleAppError(error);
      } finally {
        commonStore.setLoading(false);
      }
    })();
  }, []);

  return (
    <Box>
      <UnconfirmedTransferTable
        data={manualTransferStore.unconfirmedTransfers}
      />
    </Box>
  );
});
